import { STYLE_SHEET_IDS } from "@client/lib/styleSheet";
import { getScreenType } from "@client/lib/viewport";
import { styleSheetIdSelector } from "@client/selectors";
import { type ViewportAppState, type ViewportAppStateBase } from "@client/types/AppState/viewport";
import classnames from "classnames";
import { isNull } from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import { type ResizePayload, useResizeDetector } from "react-resize-detector";
import { TEXT_TAGS } from "../Containers/HTML/Assets/StyleSheet/Item/Color";
import { getStyleSheetClassName } from "../Containers/HTML/Assets/StyleSheet/lib";

export interface ViewportProps {
  className?: string;
  id?: string;
  isEditMode: boolean;
  viewport: ViewportAppState;
  children?: any;
}

export interface ViewportActionProps {
  onScreenUpdate: (data: ViewportAppStateBase) => void;
}

type ViewportComponentProps = ViewportProps & ViewportActionProps;

const Viewport = (props: ViewportComponentProps) => {
  const updateViewport = React.useCallback(
    (args: ResizePayload) => {
      if (isNull(args.width)) return;

      const screen = getScreenType(args.width);
      const newViewport = {
        screen
      };

      if (props.viewport.screen !== newViewport.screen) {
        props.onScreenUpdate(newViewport);
      }
    },
    [props.onScreenUpdate, props.viewport]
  );

  const { ref } = useResizeDetector({
    handleHeight: false,
    handleWidth: true,
    onResize: updateViewport,
    refreshMode: "throttle",
    refreshRate: 30,
    skipOnMount: false
  });

  const styleSheetId = useSelector(styleSheetIdSelector);

  const className = React.useMemo(() => {
    return [
      ...TEXT_TAGS.map((x) => getStyleSheetClassName(x, STYLE_SHEET_IDS.defaults[x])),
      getStyleSheetClassName("link", STYLE_SHEET_IDS.defaults.link)
    ].join(" ");
  }, [styleSheetId]);

  return (
    <div ref={ref} id={props.id} className={classnames("wsc_viewport", props.className, className)}>
      <div className="content">{props.children}</div>
    </div>
  );
};

export default Viewport;
